import React from 'react'
import PropTypes from 'prop-types'
import { Nav, NavItem, Tab, Panel } from 'react-bootstrap'
import isEmpty from 'lodash/isEmpty'
import JSONTree from 'react-json-tree'

const theme = {
  scheme: 'bright',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#000000',
  base01: '#303030',
  base02: '#505050',
  base03: '#b0b0b0',
  base04: '#d0d0d0',
  base05: '#e0e0e0',
  base06: '#f5f5f5',
  base07: '#ffffff',
  base08: '#fb0120',
  base09: '#fc6d24',
  base0A: '#fda331',
  base0B: '#a1c659',
  base0C: '#76c7b7',
  base0D: '#6fb3d2',
  base0E: '#d381c3',
  base0F: '#be643c'
}

class JsonViewer extends React.Component {

  onSelect = e => console.log(e)

  render() {
    const { title, data, style } = this.props

    return (
      <Tab.Container id='tab' defaultActiveKey={1}>
        <Panel bsStyle='info' className='panel-dark'>
          <Panel.Heading fill>
            <Panel.Title>{title}</Panel.Title>
            <Nav className='nav-tabs nav-xs'>
              <NavItem eventKey={1}>Pretty</NavItem>
              <NavItem eventKey={2}>Tree</NavItem>
            </Nav>
          </Panel.Heading>
{/*        <Panel.Body>   */}
            <Tab.Content style={style} animation>
              <Tab.Pane eventKey={1}>{ isEmpty(data) ? null : <pre>{JSON.stringify(data, null, 2)}</pre> }</Tab.Pane>
              <Tab.Pane eventKey={2}>{ isEmpty(data) ? null : <JSONTree data={data} theme={theme} hideRoot/> }</Tab.Pane>
            </Tab.Content>
{/*          </Panel.Body>   */}
        </Panel>
      </Tab.Container>
    )
  }
}

JsonViewer.defaultProps = {
  title: 'JSON',
  data: [],
  style: {}
}

JsonViewer.propTypes = {
  title: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  style: PropTypes.object
}

export default JsonViewer



// WEBPACK FOOTER //
// ./src/components/widgets/JsonViewer.js